import base from './base';
import palette from './palette';

const button = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        textTransform: 'none',
        height: '40px',
      },
      contained: {
        color: palette.common.white,
        background: palette.red[600],
        '&:hover': {
          color: palette.common.white,
          background: palette.red[400],
          boxShadow: 'none',
        },
        '&:active': { background: palette.red[800] },
        '&.Mui-disabled': {
          color: palette.grey[800],
          border: '1px solid',
          borderColor: palette.grey[600],
          background: 'transparent',
        },
        '&.Mui-focusVisible': {
          '&:hover': {
            color: palette.common.white,
            background: palette.blue[700],
          },
          background: palette.blue[700],
        },
      },
      outlined: {
        color: palette.red[600],
        background: 'transparent',
        border: '1px solid',
        borderColor: palette.red[600],
        '&:hover': {
          color: palette.common.white,
          borderColor: palette.red[400],
          background: palette.red[400],
        },
        '&:active': { background: palette.red[800] },
        '&:disabled': {
          color: palette.grey[700],
          background: palette.grey[600],
        },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: base.shape.borderRadius,
        '.MuiSvgIcon-root': {
          transition: 'color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
        },
        '&:hover': {
          background: palette.grey[600],
          color: palette.common.white,
        },
        // '&.Mui-disabled': {
          // color: palette.grey[800],
          // borderColor: palette.grey[600],
        // },
      },
      colorPrimary: {
        color: palette.common.white,
        background: palette.red[600],
        '&:hover': {
          background: palette.red[400],
          color: palette.common.white,
        },
        '&.Mui-focusVisible': { background: palette.red[400] },
        '&:active': { background: palette.red[800] },
      },
      colorSecondary: {
        color: palette.red[600],
        background: palette.common.white,
        border: '1px solid',
        borderColor: palette.red[600],
        '&:hover': {
          color: palette.common.white,
          background: palette.red[400],
          '.MuiSvgIcon-root': {
            color: palette.common.white,
          },
        },
        '&.Mui-focusVisible': { background: palette.red[400] },
        '&:active': { background: palette.red[800] },
      },
      colorViolet: {
        color: palette.blue[900],
        background: palette.common.white,
        border: '1px solid',
        borderColor: palette.blue[900],
        '& .MuiSvgIcon-root': {
          color: palette.blue[900],
        },
        '&:hover': {
          color: palette.common.white,
          background: palette.blue[900],
          '& .MuiSvgIcon-root': {
            color: palette.common.white,
          },
        },
        '&.Mui-focusVisible': { background: palette.blue[900] },
        '&:active': { background: palette.blue[900] },
      },
      sizeSmall: {
        padding: 2,
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        padding: 0,
        textTransform: 'none',
        border: 'none',
        color: palette.grey[800],
        '&.Mui-selected': {
          color: palette.common.white,
          backgroundColor: palette.red[600],
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: palette.red[600],
          },
        },
        '&:hover': {
          color: palette.common.white,
          backgroundColor: palette.red[600],
          borderRadius: '4px',
        },
      },
    },
    defaultProps: {
      size: 'small',
    },
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: {
        padding: '3px',
        height: '40px',
        border: '1px solid',
        borderColor: palette.grey[600],
        background: palette.grey[100],
        '&:has(.MuiToggleButton-root:not(.Mui-selected):hover) .Mui-selected': {
          color: palette.red[600],
          backgroundColor: 'transparent',
        },
      },
    },
  },
};

export default button;
